import { type CSSProperties, type ReactNode } from 'react';

export type PlaceholderTone = 'warm' | 'cool' | 'spice' | 'leaf' | 'grain';

interface PlaceholderProps {
  tone?: PlaceholderTone;
  label: string;
  style?: CSSProperties;
  className?: string;
  children?: ReactNode;
}

export function Placeholder({ tone = 'warm', label, style, className, children }: PlaceholderProps) {
  return (
    <div className={`ph ph-${tone} ${className ?? ''}`} style={style}>
      <span style={{
        position: 'relative',
        zIndex: 1,
        padding: '4px 8px',
        background: 'rgba(0,0,0,.35)',
        borderRadius: 4,
      }}>
        {label}
      </span>
      {children}
    </div>
  );
}
